
// These javascript libraries have a jquery dependancy, but aren't built to work with requirejs
// We need to explicitly make jquery available to them by declaring in this define
// The symptoms for this problem are the error message "Cannot read property 'XXX' of undefined" where XXX is a jQuery function
define('app/js/jquery-shims',['bootstrap', 'resize', 'jquery-unobtrusive', 'knockout', 'i18next', 'datepicker', 'jquery-timepicker', 'typeahead', 'printThis', 'signalr.core', 'signalr.hubs'], function () {
    return $;
});